import React, {Component} from 'react'
import './ReportMobileTable.css'

class ReportMobileTable extends Component {

  constructor(...args) {
    super(...args)

  }
  
  componentDidMount() {

  }

  getNumberFormat(value) {
    let {numberFormat} = this.props
    if (numberFormat) {
        if (value!='0'&&value!=0&&value!=undefined&&value!=null) {
          value = value.toString()
          value = value.replace(/,/g, '')
        }
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    } else {
        return value
    }    
  }

  onRowClick(item,index){
      let {keyIndex} = this.props
      if(this.props.onRowClick!==undefined){
          if(item[keyIndex]!==undefined) {
            this.props.onRowClick(item[keyIndex],item,index)
          }else{
            this.props.onRowClick('',item,index)  
          }  
      }
  }

  renderBrand(item,fieldMap){
      if(item[fieldMap.brand]!==undefined && item[fieldMap.brand]!=''){
        return (
            <img src={"https://static.bigfix.co/img/car_brand/"+item[fieldMap.brand]+"-32x32.png"}></img>
        )
      }else{
          return ('')
      }
  }

  renderRowData() {
    let {itemlist,fieldMap} = this.props
    if (itemlist.length==0) {
        return(<tr className='text-center' colSpan={2}>ไม่พบข้อมูล</tr>)
    } else {
        return(
            itemlist.map((item,index)=> {
              return(    
                <tr key={index} onClick={this.onRowClick.bind(this,item,index)}>
                  <td style={{width:'70%'}}>
                    <div className={'title'+(this.props.ellipsis?' ellipsis':'')}>
                        {item[fieldMap.title]}
                    </div>    
                    <div className='sub-title'>
                        {fieldMap.sub_title.isArray!=undefined&&fieldMap.sub_title.isArray?
                        item[fieldMap.sub_title.sub_title].map((sitem,sindex)=>
                            <p key={sindex}>- {sitem[fieldMap.sub_title.field]}</p>
                        )
                        :
                        <p>{item[fieldMap.sub_title]} {item[fieldMap.sub_title]!=''&&item[fieldMap.date]!=''&&item[fieldMap.sub_title]!=undefined&&item[fieldMap.date]!=undefined&&item[fieldMap.sub_title]!=null&&item[fieldMap.date]!=null?'*':''} {item[fieldMap.date]}</p>
                        }
                        {this.props.renderWorkStatus!=undefined?this.props.renderWorkStatus(item[fieldMap.status],item):item[fieldMap.status]}&nbsp;<span dangerouslySetInnerHTML={{__html:item[fieldMap.sub_status]}}></span>
                    </div>    
                  </td>
                  <td className='text-right' style={{width:'30%'}}>
                    <p className='title'>{this.getNumberFormat(item[fieldMap.amount])}</p>                    
                    {this.renderBrand(item,fieldMap)}                    
                  </td>    
                </tr>
              )    
            })    
        )        
    }
  }

  render() {
      return(
          <div>
            <table className='table'>
              <tbody>
                {this.renderRowData()}
              </tbody>
            </table>
          </div>    
      )
  }
}
ReportMobileTable.defaultProps = {
    itemlist:[],
    fieldMap:[],
    numberFormat:true,
    ellipsis:true
}
export default ReportMobileTable;


// WEBPACK FOOTER //
// ./src/view/report/ReportMobileTable.js